module.exports = __webpack_public_path__ + "static/media/MegawideLogo.c580696e.png";